import React from "react";

const PictureCaption = ({ caption }) => (
  <figcaption className="d-block my-2 z-5 font-lato">{caption}</figcaption>
);

export default PictureCaption;
